import { PrivateAxiosInstance } from "config/axios";
const getAuthToken = () => {
  const userDataString = localStorage.getItem("userData");
  const userData = JSON.parse(userDataString);
  return userData?.token;
};

export const API_LIST_REPORTS = async (params) => {
  const authToken = getAuthToken(); // Get token each time before making an API request
  try {
    const response = await PrivateAxiosInstance.get("/reports/all-reports", {
      headers: {
        Authorization: `${authToken}`, // Add the Authorization header with the token
      },
      params: params, // Include dynamic params
    });
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_DELETE_REPORT = async (id) => {
  const authToken = getAuthToken(); // Get token each time before making an API request
  try {
    const response = await PrivateAxiosInstance.delete(
      `/reports/report/${id}`,
      // data,
      {
        headers: {
          Authorization: `${authToken}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    throw error; 
  }
};
